module.exports = __webpack_public_path__ + "img/002.dc3bbd63.jpg";